<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew

========================================================================================== -->

<template>
  <vx-card>
    <div class="flex items-center justify-between">
      <div class="flex items-center ">
        <img v-if="thumbnail" :src="thumbnail"  width="125" class="rounded-lg hidden sm:block mr-5" draggable="false"/>
        <div class="">
          <h1 class="font-bold">{{ name }}</h1>
          <p class="font-light">{{ terms_count }} Total Terms</p>
          <vs-button color="primary" icon-pack="feather" icon="icon-play" class="mt-2 font-bold"
                     type="gradient" @click="$router.push(`/flashcards/${id}/play`)">Practice
          </vs-button>
        </div>
      </div>
      <radial-progress-bar :diameter="115" :completed-steps="terms_completed" :total-steps="terms_count"
                           :animateSpeed="1100" timingFunc="ease" innerStrokeColor="#0000006b" startColor="#0cdc62" stopColor="#0cdc62"
                           :strokeWidth="7" :innerStrokeWidth="7">
        <h2 class="font-light">{{ percent }}%</h2>
      </radial-progress-bar>
    </div>
  </vx-card>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    thumbnail: {
      type: String,
      default: null,
      required: false
    },
    percent: {
      type: Number,
      default: 0,
      required: false
    },
    terms_completed: {
      type: Number,
      default: 0,
      required: false
    },
    terms_count: {
      type: Number,
      default: 0,
      required: false
    }
  },
  components: {
    RadialProgressBar
  }
}
</script>

